import React from "react";

import TableRowContainer from "../TableRowContainer";

import { formatTimeFromUtc } from "utils/formatters";
import { icons } from "constants/icons";
import { StatusENUM } from "types/common";

type Props = {
  clinicId: string;
  name: string;
  address: string;
  createdAt: string;
  status: StatusENUM;
  clinicAdmins: string[];
  disableClinic: (clinicId: string, status: StatusENUM) => void;
  editClinic: (clinicId: string) => void;
  addClinicAdmin: (clinicId: string) => void;
};

const TableRow = React.memo(
  ({
    clinicId,
    name,
    address,
    status,
    createdAt,
    clinicAdmins,
    disableClinic,
    editClinic,
    addClinicAdmin,
  }: Props) => {
    return (
      <>
        <TableRowContainer
          id={clinicId}
          onEditClick={() => editClinic(clinicId)}
          onDisableClinic={() => disableClinic(clinicId, status)}
          onAddAdminClick={() => addClinicAdmin(clinicId)}
          status={status}
        >
          <div className="w-[300px]">
            <p>{name}</p>
          </div>

          <div className="w-[300px]  pr-10">
            {address ? <p>{address}</p> : <p>-</p>}
          </div>

          <div className="w-[250px] pr-10">
            {clinicAdmins?.length ? (
              <p>{clinicAdmins?.join(", ")}</p>
            ) : (
              <p>-</p>
            )}
          </div>

          <div className="w-[200px]">
            {createdAt ? <p>{formatTimeFromUtc(createdAt)}</p> : <p>-</p>}
          </div>

          <div className="w-[100px]">
            <img
              alt="status"
              src={
                status === StatusENUM.active
                  ? icons.clinicActiveStatus
                  : icons.clinicDisabledStatus
              }
            />
          </div>
        </TableRowContainer>
      </>
    );
  }
);

export default TableRow;
